import { useState } from "react";
import { motion } from "framer-motion";
import { Lightbulb, Check, ArrowRight } from "lucide-react";
import { useLang } from "../../context/LanguageContext";

const embed = (url) => {
  if (!url) return null;
  const yt = url.match(/(?:youtu\.be\/|v=)([\w-]{6,})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vimeo = url.match(/vimeo\.com\/(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
  return null;
};

export const TheoryBlock = ({ block, onDone }) => {
  const { t } = useLang();
  const frame = embed(block.video_url);
  return (
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="card-dark p-7 sm:p-10" data-testid="learn-block-theory">
      <span className="badge-lime inline-flex items-center gap-2"><Lightbulb className="w-3.5 h-3.5" /> {t("learn.theory")}</span>
      <h2 className="font-heading font-black text-2xl sm:text-3xl text-[#0B1B3A] mt-5 leading-snug" data-testid="learn-theory-title">{block.title}</h2>
      {block.body && (
        <div className="mt-5 space-y-4 max-w-[70ch]" data-testid="learn-theory-body">
          {block.body.split(/\n{2,}/).map((p, i) => (
            <p key={i} className="text-base text-[#334155] leading-[1.8] whitespace-pre-wrap">{p}</p>
          ))}
        </div>
      )}
      {block.image_url && <img src={block.image_url} alt={block.title} className="w-full rounded-[22px] border border-[#E2E8F0] mt-6 object-cover max-h-[340px]" />}
      {frame && (
        <div className="mt-6 aspect-video rounded-[22px] overflow-hidden border border-[#E2E8F0]">
          <iframe src={frame} title={block.title} allowFullScreen className="w-full h-full" />
        </div>
      )}
      {(block.key_points || []).length > 0 && (
        <ul className="mt-7 space-y-3" data-testid="learn-theory-keypoints">
          {block.key_points.map((point) => (
            <li key={point} className="flex items-start gap-3">
              <span className="w-6 h-6 rounded-full bg-[#EEF4FF] text-[#1D4ED8] flex items-center justify-center shrink-0 mt-0.5">
                <Check className="w-3.5 h-3.5" />
              </span>
              <span className="text-sm font-semibold text-[#1E293B]">{point}</span>
            </li>
          ))}
        </ul>
      )}
      <button data-testid="learn-theory-continue" onClick={() => onDone(true)} className="btn-blue mt-9">
        {t("learn.gotIt")} <ArrowRight className="w-4 h-4" />
      </button>
    </motion.div>
  );
};

export default TheoryBlock;
